import React, { useState } from 'react'

import HomeContainer from '../../Container/HomeContainer2'
import VocationalResumeContents from '../VocationalResumeContents'

import Spinner from '../../../Components/Spinner/Spinner'

import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { selectUserDetails } from '../../../redux/homePage/homePage.selectors'

const VocationalPreviewResume = ({ user }) => {
  if (user) {
    return (
      <HomeContainer
        user={user}
        isViewAsTeacher={false}
        footer={null}
        isShowWhereby={false}
        isShowPoliceCheckWwcc={true}
        tabResumeActive={false}
        tabVetResumeActive={true}
      >
        <VocationalResumeContents user={user} isViewAsTeacher={false} />
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

const mapStateToProps = createStructuredSelector({
  user: selectUserDetails,
})

export default connect(mapStateToProps)(VocationalPreviewResume)
